// extracted by mini-css-extract-plugin
module.exports = {"rewards":"styles_rewards__1rrbn","requires":"styles_requires__3F_ai"};